import { apiClient, APIResponse, extractApiError, buildQuery } from './api';

export const sourcesAPI = {
  async list() {
    try {
      const { data } = await apiClient.get('/income/sources/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as fontes.'),
      );
    }
  },

  async create(payload) {
    try {
      const { data } = await apiClient.post('/income/sources/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar a fonte.'),
      );
    }
  },

  async update(id, payload) {
    try {
      const { data } = await apiClient.patch(`/income/sources/${id}/`, payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar a fonte.'),
      );
    }
  },

  async remove(id) {
    try {
      await apiClient.delete(`/income/sources/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível eliminar a fonte.'),
      );
    }
  },

  // CHANGE v2 §6: catálogo estático e bulk-create para o onboarding.
  async suggestions() {
    try {
      const { data } = await apiClient.get('/income/sources/suggestions/');
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar as sugestões.'),
      );
    }
  },

  async bulkCreate(sources) {
    try {
      const { data } = await apiClient.post('/income/sources/bulk/', {
        sources,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar as fontes.'),
      );
    }
  },

};

export const recordsAPI = {
  async list(params) {
    try {
      const { data } = await apiClient.get(
        `/income/records/${buildQuery(params)}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar os registos.'),
      );
    }
  },

  async retrieve(id) {
    try {
      const { data } = await apiClient.get(`/income/records/${id}/`);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o registo.'),
      );
    }
  },

  async create(payload) {
    try {
      const { data } = await apiClient.post('/income/records/', payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível criar o registo.'),
      );
    }
  },

  async update(id, payload) {
    try {
      const { data } = await apiClient.patch(`/income/records/${id}/`, payload);
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível actualizar o registo.'),
      );
    }
  },

  async remove(id) {
    try {
      await apiClient.delete(`/income/records/${id}/`);
      return APIResponse.success(null);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível eliminar o registo.'),
      );
    }
  },

  async bulkUpsert({ year, month, records }) {
    try {
      const { data } = await apiClient.post('/income/records/bulk-upsert/', {
        year,
        month,
        records,
      });
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível guardar os registos.'),
      );
    }
  },
};

export const incomeAPI = {
  async getMonthlySummary(params) {
    try {
      const { data } = await apiClient.get(
        `/income/monthly-summary/${buildQuery(params)}`,
      );
      return APIResponse.success(data);
    } catch (error) {
      return APIResponse.error(
        extractApiError(error, 'Não foi possível carregar o resumo mensal.'),
      );
    }
  },

  // CHANGE v2 §18 + §19: allocate/whatIfSimulator removidos (endpoints saíram).
};
